// extracted by mini-css-extract-plugin
module.exports = {"deleteMemoryBtn":"DeleteMemory_deleteMemoryBtn__3-qsV","icon":"DeleteMemory_icon__2_0Rc"};